<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="logoBlanco.png" alt="Logo Szendex" width="259" height="76" />
                  <h3 class="flex my-4 primary--text">{{$t('login.zonaClientes')}}</h3>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    :label="$t('login.usuario')"
                    type="text"
                    v-model="model.Username"
                    @keyup.enter="login"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    :label="$t('login.contraseña')"
                    id="password"
                    type="password"
                    v-model="model.Password"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login">{{$t('login.iniciarSesion')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    V{{versionLocal}}
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { version } from "../../package.json";

export default {
  name: "Login",
  data: () => ({
    model: {
      Username: "",
      Password: ""
    },
    versionLocal: "",
    usuariosPermitidos: ["Querol001", "Querol002", "Querol003", "Querol005", "Querol006", "Querol007", "Querol008", "Querol009", "Querol011", "Querol012", "Querol013", "Querol014", "Querol015", "Querol018", "Querol021", "Querol025", "Querol026", "Querol028", "Querol032", "Querol033", "Querol034", "Querol035", "Querol037", "Querol039", "Querol040", "Querol045", "Querol046", "Querol047", "Querol048", "Querol061", "Querol062", "Querol063", "Querol064", "Querol066", "Querol067", "Querol080"],
  }),
  methods: {
    ...mapActions("Auth", ["signIn"]),
    async login() {
      let ok = await this.signIn(this.model);
      if (ok){
        if(this.$store.state.Auth){
          if(this.usuariosPermitidos.indexOf(this.$store.state.Auth.Login.Username)!==-1){
            this.$router.push("/servicioscliente");
          }else{
            this.$router.push("/servicios/create");
          }
        }
      }
    }
  },
  computed: {
    ...mapState(["Auth"])
  },
  mounted() {
    this.versionLocal = version;
  }
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
